import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'sh-info-text',
  templateUrl: './info-text.component.html',
  styleUrls: ['./info-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class InfoTextComponent {
  @Input() text: string;
  @Input() fullHeight = false;
  @Input() severity: 'info' | 'warn' | 'error' | 'success' = 'info';
  @Input() iconClass: string;
}
